<template>
  <DemoTemplate
    title="Input and Textarea"
    description="A growing collection of 77 input and textarea components built with Next.js and TailwindCSS."
    :columns="3"
  >
    <div class="group/item relative" v-for="cmp in componentList">
      <component :is="cmp" />
    </div>
  </DemoTemplate>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import DemoTemplate from "../templates/DemoTemplate.vue";

const componentList = [
  defineAsyncComponent(() => import("../atoms/inputs/Input-01.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-02.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-03.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-04.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-05.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-06.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-07.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-08.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-09.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-10.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-11.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-12.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-13.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-14.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-15.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-16.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-19.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-20.vue")),
  defineAsyncComponent(() => import("../atoms/inputs/Input-23.vue")),
];
</script>
